// extracted by mini-css-extract-plugin
export default {"doc-link":"bZfzCBBWyl","docLink":"bZfzCBBWyl"};
    if(module.hot) {
      // 1648554211825
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  